import React, { memo } from 'react'

const LoadingSpinner = memo(() => (<i className="fal fa-spinner fa-spin" />))
export default LoadingSpinner
